export const extractErrorMessage = function (error, defaultErrorMessage) {
    return new Promise(function (resolve, reject) {

        if (error.response === undefined) {
            resolve(defaultErrorMessage)
        } else {
            error.response.json().then(elem => {
                resolve(elem.errorMessage)
            });
        }

    })
}